export default {
    setQueues(state, payload) {
        state.queues = payload.selectedQueues.sort((x, y) => x.order - y.order);
        state.ignoredQueues = payload.unSelectedQueues.sort((x, y) => x.order - y.order);
    },
    setQueueUsers(state, payload) {
        state.users = payload;
    },
    setLiveFeedCounts(state, payload) {
        state.liveFeedCounts = payload;
    },
    setStats(state, payload) {
        state.stats = payload;
    }
}